import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
// material
import CloseIcon from '@material-ui/icons/Close';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
} from '@material-ui/core';
import ViewOfficialRequest from 'src/pages/dashboard/ViewOfficialRequest';
import { PRESERVE_WHITESPACE_SX } from 'src/utils/preserveWhitespace';
//


const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
 function FullScreenDialogSalesOrder({
  open,
   setOpen,
   projectId:initialProjectId,
   projectName:initialProjectName,
   isEditSalesOrder:initialIsEditEstimate,
   combineGroupedInvoice: initialCombineGroupedInvoice = false,
   setRenderCards,
   renderCards,
   removePopupData,
   isFromCompletedTab,
   userType,
   userId,
   From,
   teamId,
    openEmailModal,
    setOpenEmailModal,
    mainCurrentTab,
  }) {

  const [dataChanged, setDataChanged] = useState(false); 
// const[jobCostId,setJobCostId]=useState('');

  /** Filled by ViewOfficialRequest when popupOn: returns true if it handled one step (stay open). */
  const headerStepBackRef = useRef(() => false);

  // create state for heading change
const [heading, setHeading] = useState("")

const [projectId, setProjectId] = useState(
     localStorage.getItem('salesOrderProjectId') || initialProjectId || ''
);
const [projectName, setProjectName] = useState(
    localStorage.getItem('salesOrderProjectName') || initialProjectName || ''
);

// useEffect(() => {
//   if(openEmailModal){
//     setProjectName(localStorage.getItem('salesOrderName') || initialProjectName || '');
//   }
// }, [openEmailModal]);

// console.log("projectnamr",projectName);


const ndfd=localStorage.getItem('salesOrderProjectName')
console.log("FullScreenDialogSalesOrder=====ndfd",ndfd)
console.log("FullScreenDialogSalesOrder=====projectName",projectName)
console.log("FullScreenDialogSalesOrder=====initialProjectName",initialProjectName)
let edit =localStorage.getItem('isEditSalesOrder')
const [isEditSalesOrder, setIsEditSalesOrder] = useState(
    initialIsEditEstimate ||edit ||  false
);
const [combineGroupedInvoice, setCombineGroupedInvoice] = useState(
  localStorage.getItem('salesOrderCombineGrouped') === 'true' || !!initialCombineGroupedInvoice
);

  const handleExitSalesOrderEditMode = useCallback(() => {
    setIsEditSalesOrder(false);
    localStorage.setItem('isEditSalesOrder', 'false');
  }, []);

useEffect(() => {
  if (open) {
    localStorage.setItem('salesOrderProjectId', projectId);
    localStorage.setItem('salesOrderProjectName', projectName);
    localStorage.setItem('isEditSalesOrder', isEditSalesOrder);
    localStorage.setItem('salesOrderOpenPopup', 'true');
  } else {
    // localStorage.removeItem('salesOrderProjectId');
    // localStorage.removeItem('salesOrderProjectName');
    // localStorage.removeItem('isEditSalesOrder');
    localStorage.removeItem('salesOrderOpenPopup',);
    localStorage.removeItem('salesOrderCombineGrouped');
  }
}, [open, projectId, projectName, isEditSalesOrder]);
useEffect(() => {
  if (open) {
    setProjectId(localStorage.getItem('salesOrderProjectId') || initialProjectId || '');
    setProjectName(localStorage.getItem('salesOrderProjectName') || initialProjectName || '');
    let edit =localStorage.getItem('isEditSalesOrder')
    setIsEditSalesOrder( edit || initialIsEditEstimate || false);
    setCombineGroupedInvoice(
      localStorage.getItem('salesOrderCombineGrouped') === 'true' || !!initialCombineGroupedInvoice
    );
  }
}, [open, initialProjectId, initialProjectName, initialIsEditEstimate, initialCombineGroupedInvoice]);
  const handleClose = () => {

    setProjectId("");
    setProjectName("");
    setIsEditSalesOrder("");
    setOpen(false);
    localStorage.removeItem('salesOrderProjectId');
    localStorage.removeItem('salesOrderProjectName');
    localStorage.removeItem('isEditSalesOrder');
    localStorage.removeItem('salesOrderOpenPopup',);
    localStorage.removeItem('salesOrderCombineGrouped');
    // if (dataChanged) {
      setRenderCards(!renderCards);
      setDataChanged(false); // Reset the flag after triggering the re-render
    // }
    removePopupData?.()
  };

  const handleHeaderClose = () => {
    const tryStep = headerStepBackRef.current;
    if (typeof tryStep === 'function' && tryStep()) return;
    handleClose();
  };

  const handleDataChange = () => {
    setDataChanged(true); 
    console.log('Entered=handleDataChange')
  };
  return (
    <>
      <Dialog fullScreen open={open} onClose={handleHeaderClose} TransitionComponent={Transition}>
        <AppBar position="relative" mb={3}>
          <Toolbar>
            <Typography variant="h6" sx={{ flex: 1, ml: 2, ...PRESERVE_WHITESPACE_SX }}>
              {heading || projectName}
            </Typography>
              <CloseIcon onClick={handleHeaderClose} sx={{fontSize:'2.7rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <MemoizedViewOfficialRequest
          popupOn={true}
          idOfProject={projectId}
          isEditSalesOrder={isEditSalesOrder}
          headerStepBackRef={headerStepBackRef}
          onExitSalesOrderEditMode={handleExitSalesOrderEditMode}
          closeView={handleClose}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          onDataChange={handleDataChange}
          isFromCompletedTab={isFromCompletedTab}
          openEmailModal={openEmailModal}
          setOpenEmailModal={setOpenEmailModal}
          heading={heading}
          setHeading={setHeading}
          mainCurrentTab={mainCurrentTab}
          combineGroupedInvoice={combineGroupedInvoice}
          
        />
      </Dialog>
    </>
  );
}
const MemoizedViewOfficialRequest = React.memo(ViewOfficialRequest);

export default React.memo(FullScreenDialogSalesOrder);